import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

import { ExportFieldOption } from 'src/app/@shared/export/export-field-resolver';

@Component({
  selector: 'proto-export-field-selection',
  standalone: false,
  styleUrls: ['./export-field-selection.component.scss'],
  templateUrl: './export-field-selection.component.html',
})
export class ExportFieldSelectionComponent implements OnInit {
  @Input() public fields: ExportFieldOption[] = [];

  public selectedFieldKeys: string[] = [];

  constructor(private modalController: ModalController) {}

  public get hasSelectedFields(): boolean {
    return this.selectedFieldKeys.length > 0;
  }

  public get allFieldsSelected(): boolean {
    return this.fields.length > 0 && this.selectedFieldKeys.length === this.fields.length;
  }

  public ngOnInit(): void {
    this.selectedFieldKeys = this.fields.map((field) => {
      return field.key;
    });
  }

  public dismiss(role: 'cancel' | 'confirm' = 'cancel'): void {
    this.modalController.dismiss({
      selectedFieldKeys: this.selectedFieldKeys,
    }, role).catch();
  }

  public onFieldCheckedChanged(fieldKey: string, checked: boolean): void {
    if (checked) {
      if (!this.selectedFieldKeys.includes(fieldKey)) {
        this.selectedFieldKeys = [...this.selectedFieldKeys, fieldKey];
      }

      return;
    }

    this.selectedFieldKeys = this.selectedFieldKeys.filter((selectedFieldKey) => {
      return selectedFieldKey !== fieldKey;
    });
  }

  public onToggleAllChanged(checked: boolean): void {
    if (checked) {
      this.selectedFieldKeys = this.fields.map((field) => {
        return field.key;
      });

      return;
    }

    this.selectedFieldKeys = [];
  }
}
